import { render, staticRenderFns } from "./FooterLogin.vue?vue&type=template&id=470a4eff&scoped=true&"
import script from "./FooterLogin.vue?vue&type=script&lang=ts&"
export * from "./FooterLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLogin.vue?vue&type=style&index=0&id=470a4eff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a4eff",
  null
  
)

export default component.exports